import { render, staticRenderFns } from "./ProveedorFormComponent.vue?vue&type=template&id=13b35e60&"
import script from "./ProveedorFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProveedorFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports